module.exports = __webpack_public_path__ + "assets/images/project/people/boy.svg?v=2b4ae4b4";